export default "__VITE_ASSET__CN_OH9Tr__"